if (!customElements.get('free-shipping-goal-v2')) {
  class FreeShippingGoalV2 extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const currencyRate = Number(window.Shopify?.currency?.rate || 1);
      this.regularThreshold = Number(this.dataset.regularThreshold) * currencyRate || 0;
      this.expressThreshold = Number(this.dataset.expressThreshold) * currencyRate || 0;
      this.moneyFormat = window.FoxTheme?.settings?.moneyFormat || '${{amount}}';

      // Calculate regular milestone position as percentage of express threshold
      this.regularPosition = this.expressThreshold > 0 
        ? (this.regularThreshold / this.expressThreshold) * 100 
        : 0;

      // Cache DOM elements
      this.messageEl = this.querySelector('[data-message]');
      this.regularBar = this.querySelector('[data-bar-regular]');
      this.expressBar = this.querySelector('[data-bar-express]');
      this.regularMilestone = this.querySelector('[data-milestone-regular]');
      this.expressMilestone = this.querySelector('[data-milestone-express]');

      // Position regular milestone
      if (this.regularMilestone) {
        this.regularMilestone.style.left = `${this.regularPosition}%`;
      }
    }

    connectedCallback() {
      this.updateProgress(Number(this.dataset.cartTotal));
      this.boundCartUpdate = this.handleCartUpdate.bind(this);
      document.addEventListener('cart:updated', this.boundCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.boundCartUpdate);
    }

    handleCartUpdate(event) {
      this.updateProgress(event.detail?.cart?.items_subtotal_price || 0);
    }

    formatMoney(cents) {
      if (window.FoxTheme?.Currency?.formatMoney) {
        return window.FoxTheme.Currency.formatMoney(cents, this.moneyFormat);
      }
      const amount = (cents / 100).toFixed(2);
      return this.moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }

    updateProgress(cartTotalCents) {
      const cartTotal = cartTotalCents / 100;

      // Hide if cart is empty
      if (cartTotalCents <= 0) {
        this.classList.add('hidden');
        return;
      }
      this.classList.remove('hidden');

      // Calculate percentages (express threshold = 100%)
      const totalPercent = this.expressThreshold > 0 
        ? Math.min((cartTotal / this.expressThreshold) * 100, 100) 
        : 0;
      const regularFillPercent = Math.min(totalPercent, this.regularPosition);

      // Determine completion states
      const regularComplete = cartTotal >= this.regularThreshold;
      const expressComplete = cartTotal >= this.expressThreshold;

      // Update green bar (fills up to regular milestone)
      if (this.regularBar) {
        this.regularBar.style.width = `${regularFillPercent}%`;
      }

      // Update blue bar and animation states
      if (this.expressBar) {
        if (regularComplete && !expressComplete) {
          this.expressBar.style.width = `${totalPercent}%`;
          this.classList.add('express-active');
          this.classList.remove('express-complete');
        } else if (expressComplete) {
          this.expressBar.style.width = '100%';
          this.classList.remove('express-active');
          this.classList.add('express-complete');
        } else {
          this.expressBar.style.width = '0%';
          this.classList.remove('express-active', 'express-complete');
        }
      }

      // Update milestone visual states
      if (this.regularMilestone) {
        this.regularMilestone.classList.toggle('is-reached', regularComplete);
      }
      if (this.expressMilestone) {
        this.expressMilestone.classList.toggle('is-reached', expressComplete);
      }

      // Update message text
      this.updateMessage(cartTotal, regularComplete, expressComplete);
    }

    updateMessage(cartTotal, regularComplete, expressComplete) {
      if (!this.messageEl) return;

      if (expressComplete) {
        this.messageEl.className = 'shipping-goal-v2__message';
        this.messageEl.innerHTML = '<span class="shipping-goal-v2__message--express-success">FREE Express Shipping unlocked!</span>';
      } else if (regularComplete) {
        const remaining = this.expressThreshold - cartTotal;
        this.messageEl.className = 'shipping-goal-v2__message shipping-goal-v2__message--express';
        this.messageEl.innerHTML = `FREE Regular Shipping unlocked! Spend <strong>${this.formatMoney(remaining * 100)}</strong> more for Express!`;
      } else {
        const remaining = this.regularThreshold - cartTotal;
        this.messageEl.className = 'shipping-goal-v2__message';
        this.messageEl.innerHTML = `Spend <strong>${this.formatMoney(remaining * 100)}</strong> more for free regular shipping!`;
      }
    }
  }

  customElements.define('free-shipping-goal-v2', FreeShippingGoalV2);
}
